export default __webpack_public_path__ + "static/media/aboutus_background.3dd25bd8.png";